export const asIs = (v) => v;

export const extractKeyFromLabel = (data) => data.key;
export const extractIntervalIdFromTime = (data) => {
  return data.context.id;
};

export const mapHouses = (houses) => houses.map((house) => house.id);

export const mapRelatedAddresses = (rooms) =>
  rooms.map((room) => ({
    id: room.id,
    childreAddresses: room.relatedRooms.map((relatedRoom) => relatedRoom.id),
  }));

export const isEmpty = (value) => {
  if (value === null || value === undefined) return true;

  if (typeof value === 'string') {
    return value.trim() === '';
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};
